import { createSlice } from '@reduxjs/toolkit';

// Get user from localstorage
const brand = JSON.parse(localStorage.getItem('brand'));

// Get token from localstorage
const token = JSON.parse(localStorage.getItem('token'));

// Get selected brand ID from localstorage
const selectedBrandId = localStorage.getItem('selectedBrandId');

const initialState = {
  brand: brand || null,
  token: token || null,
  refreshTokenExecuted: false, // Flag para controlar si ya se ejecutó el refresh token
  selectedBrandId: selectedBrandId || null, // ID de la marca actualmente seleccionada
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      state.token = action.payload.token;
      localStorage.setItem('token', JSON.stringify(state.token));
    },
    logOut: state => {
      state.brand = null;
      state.token = null;
      state.refreshTokenExecuted = false;
      state.selectedBrandId = null;
      localStorage.removeItem('brand');
      localStorage.removeItem('token');
      localStorage.removeItem('selectedBrandId');
      window.location.reload();
    },
    setBrandData: (state, action) => {
      state.brand = action.payload.brand;
      localStorage.setItem('brand', JSON.stringify(state.brand));
      
      // Si no hay marca seleccionada, usar la marca actual como predeterminada
      if (!state.selectedBrandId && state.brand?._id) {
        state.selectedBrandId = state.brand._id;
        localStorage.setItem('selectedBrandId', state.selectedBrandId);
      }
    },
    setRefreshTokenExecuted: (state, action) => {
      state.refreshTokenExecuted = action.payload;
    },
    setSelectedBrandId: (state, action) => {
      state.selectedBrandId = action.payload;
      localStorage.setItem('selectedBrandId', action.payload);
    },
  },
});

export const { 
  setCredentials, 
  logOut, 
  setBrandData, 
  setRefreshTokenExecuted,
  setSelectedBrandId 
} = authSlice.actions;

export default authSlice.reducer;

export const selectCurrentBrand = state => state.auth.brand;
export const selectCurrentToken = state => state.auth.token;
export const selectRefreshTokenExecuted = state => state.auth.refreshTokenExecuted;
export const selectSelectedBrandId = state => state.auth.selectedBrandId;
